import { render, staticRenderFns } from "./SettingsPreferencesGeneralAccounts.vue?vue&type=template&id=72bfa1d6&"
import script from "./SettingsPreferencesGeneralAccounts.vue?vue&type=script&lang=js&"
export * from "./SettingsPreferencesGeneralAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VSwitch,VTooltip})
